import { computed, inject, Injectable, signal } from '@angular/core';
import { ListingPageModelAbstract } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model-abstract';
import { ListingPageModel } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { ListingTableComponent } from 'src/app/shared/components/listing-table/listing-table.component';
import { TAB_VALUE } from 'src/app/shared/components/listing-page/listing-page.types';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { ListingPageModelRegistry } from '@portal/shared/components/listing-page/services/listing-page-model/listing-page-model-registry.service';
import { ListingPageId } from '@portal/shared/components/listing-page/store/listing-page-store.types';
import { OrderDirection } from 'src/app/pages/equipment/devices/components/devices.models';
import { BaseStationListingFiltersSourceService } from './base-stations-listing-filters-source.service';
import { BaseStationListingDataSourceService } from './base-stations-listing-data-source.service';
import { BaseStationListingExportConfigService } from './base-stations-listing-export-config.service';
import { createBaseStationColumns } from './base-stations-listing.columns';
import { BASE_STATION_DEFAULT_SEARCH_TYPE, BASE_STATION_SEARCH_TYPES } from './base-stations-listing.search';
import { BASE_STATION_SORT_FIELD } from './base-stations-listing.sort';

@Injectable()
export class BaseStationListingModelService extends ListingPageModelAbstract implements ListingPageModel {
  readonly listingPageModelRegistry = inject(ListingPageModelRegistry);

  readonly pageTitle = TranslateRegistry.get.MAIN_MENU.TITLE.BASE_STATIONS;
  readonly searchTypeList = signal(BASE_STATION_SEARCH_TYPES);
  readonly selectedSearchType = signal(BASE_STATION_DEFAULT_SEARCH_TYPE);
  readonly sorting = signal({
    columnName: BASE_STATION_SORT_FIELD['provisioningDateTime'],
    orderDirection: OrderDirection.DESC
  });
  readonly tableColumns = computed(() => createBaseStationColumns());
  readonly filterSource = inject(BaseStationListingFiltersSourceService);
  readonly dataSource = inject(BaseStationListingDataSourceService);
  readonly exportConfig = inject(BaseStationListingExportConfigService);

  readonly tableCmp = ListingTableComponent;
  readonly defaultTab = TAB_VALUE.Table;
  readonly sortField = BASE_STATION_SORT_FIELD;
  readonly exportButtonVisible = true;

  get pageId(): ListingPageId {
    return ListingPageId.BaseStationsProvisioning;
  }

  constructor() {
    super();
    this.listingPageModelRegistry.add(ListingPageId.BaseStationsProvisioning, this);
  }
}
